import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { AppBridge } from 'novo-elements';
import { environment } from 'src/environments/environment';

@Injectable()
export class AppBridgeMspService {
  onRegistered: EventEmitter<boolean> = new EventEmitter();
  private appBridgeConfig: any = environment.appBridgeConfig;
  private readonly waitTime: number = environment.production ? 500 : 2000;
  private readonly currentBullhornUrl: any;
  private requiresWindowObject = false;
  private registered = false;
  private registrationAttempts = 0;
  private readonly maxRegistrationAttempts = 4;
  private readonly bridge: AppBridge;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute
  ) {
    this.currentBullhornUrl = this.route.snapshot.queryParamMap.get('currentBullhornUrl');
    this.bridge = new AppBridge('MSP Companies');
    this.bridge.tracing = !environment.production;
  }

  execute(execute: (bridge: AppBridge) => void): void {
    if (this.registered) {
      execute(this.bridge);
    } else {
      setTimeout(() => {
        if (this.registered) {
          execute(this.bridge);
        }
      }, this.waitTime);
    }
  }

  registerCustomAction(): void {
    this.requiresWindowObject = true;
    this.appBridgeConfig.url = this.currentBullhornUrl.replace(/.*BullhornStaffing/g, '/BullhornStaffing');
    this.register();
  }

  register(addtlConfig = {}): void {
    this.registrationAttempts++;
    this.bridge.register(this.appBridgeConfig).then((windowName: string) => {
      this.registered = !this.requiresWindowObject || windowName != null;
      if (this.registered) {
        this.onRegistered.emit(true);
      } else {
        this.registerRetry();
      }
    }, (err: any) => {
      this.registerRetry(err);
    });
  }

  close(): void {
    this.bridge.close();
  }

  refresh(): void {
    this.bridge.refresh();
  }

  private registerRetry(err: any = null) {
    if (!this.registered && this.registrationAttempts < this.maxRegistrationAttempts) {
      setTimeout(() => {
        this.register();
      }, this.waitTime);
    } else {
      this.onRegistered.emit(false);
      if (err) {
        console.error(err);
      }
    }
  }
} 